import Item from '@/models/Item';
import api from '@/services/HttpService';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Loader from '../Loader';
import './style.scss';
interface Props {
    content: Item;
    finishLesson(): void;
    startLesson(): void;
}

const LMSHtmlPlayer: React.FC<Props> = (props: Props) => {
    const lessonId: number = Number(useParams<{ lessonId: string }>().lessonId);

    const { content, startLesson, finishLesson } = props;
    const [loading, setLoading] = useState<boolean>(true);
    const [currentContentPath, setCurrentContentPath] = useState<string>();
    const GAP = 44;
    const PERCENTUAL_TO_PASS = 70;
    let finishedRequestSent = false;

    useEffect(() => {
        startLesson();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [lessonId]);

    const handleResize = () => {
        const iframe = document.getElementById('iframe-player') as HTMLIFrameElement;
        if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.body) {
            const height = iframe.contentWindow.document.body.offsetHeight + GAP;
            iframe.style.height = height + 'px';
        }
    };

    const writeHtmlInIframe = async () => {
        if (currentContentPath) {
            const html = await getHtmlFromPath();
            const iframe = document.getElementById('iframe-player') as HTMLIFrameElement;
            if (iframe?.contentWindow) {
                iframe.contentWindow.document.write(html);
                resizeIFrame(iframe);
            }
        }
    };

    const getHtmlFromPath = async () => {
        try {
            const response = await api.get(currentContentPath || '');
            return response.data;
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(err);
            return '';
        }
    };

    const resizeIFrame = (iframe: HTMLIFrameElement) => {
        setTimeout(() => {
            setLoading(false);
            if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.body) {
                const height = iframe.contentWindow.document.body.offsetHeight + GAP;
                iframe.style.height = height + 'px';
                calculatePercent();
            }
        }, 1000);
    };

    const calculatePercent = () => {
        const docElement = window.document.documentElement as HTMLElement;
        const percent = ((docElement.scrollTop + docElement.clientHeight) / docElement.scrollHeight) * 100;

        if (!finishedRequestSent && (docElement.scrollHeight <= docElement.clientHeight || percent >= PERCENTUAL_TO_PASS)) {
            finishedRequestSent = true;
            finishLesson();
        }
    };

    useEffect(() => {
        writeHtmlInIframe();
        window.addEventListener('scroll', calculatePercent);
        return () => window.removeEventListener('scroll', calculatePercent);
    }, [currentContentPath]);

    useEffect(() => {
        setCurrentContentPath(content.path);
    }, [content]);

    return (
        <div className="html-player-lms">
            {loading && <Loader />}
            <iframe className={`${loading && 'hide'}`} id="iframe-player" src="#" />
        </div>
    );
};

export default LMSHtmlPlayer;
